<app-dashboard-mobile-menu></app-dashboard-mobile-menu>
<div class="container student-assignment-wrapper mt-2">
    <div class="student-tab student-tab-assignments">
        <div class="student-tab__header">
            <span class="student-tab__text">Add an assignment:</span>
            <form (ngSubmit)="submitAssignmentsForm($event)" name="beginAssignmentForm" novalidate>
                <input
                    [(ngModel)]="assignmentCode"
                    class="student-tab__input"
                    id="enter-assignment-code"
                    name="assignmentCode"
                    placeholder="Enter code e.g., banana1234"
                    required
                    type="text"
                />
                <input class="student-tab__button btn" id="join-btn" type="submit" value="Go" />
            </form>
        </div>
        <div class="student-tab__body">
            <ul class="assignments no-list-style" id="assignmentsList">
                <li *ngIf="!assignments || !assignments.items.length">
                    <p>You do not have any assignments.</p>
                </li>
                <li *ngIf="!assignments">
                    <div class="ring-loader-container">
                        <div class="ring-loader"></div>
                    </div>
                </li>
                <ng-container *ngIf="assignments">
                    <li
                        *ngFor="let assignment of assignments.items"
                        [ngClass]="{ closed: !isActive(assignment.id) }"
                        class="assignment-tray-item"
                    >
                        <span class="assignment-show-info">
                            <i (click)="toggleActive(assignment.id)" class="lm lm-dash-add"></i>
                            <i (click)="toggleActive(assignment.id)" class="lm lm-dash-delete"></i>
                        </span>
                        <div class="assignment-content">
                            <i
                                *ngIf="!assignment.activity.isILP"
                                class="lm lm-assignment-icon lm-screen-text"
                            ></i>
                            <i
                                *ngIf="assignment.activity.isILP"
                                class="lm lm-assignment-icon lm-ilp"
                            ></i>
                            <span class="title">{{ assignment.activity.name }}</span>
                            <span class="assignment-status">
                                <img
                                    *ngIf="assignment.completed"
                                    alt="checkmark image"
                                    class="checkmark-img"
                                    src="{{ checkSignURL }}"
                                />
                                <a
                                    *ngIf="!assignment.completed && assignment.status === 'started'"
                                    href="{{ assignment.studentResultURL }}"
                                    target="_self"
                                    >Resume <i class="lm lm-right-arrow"></i
                                ></a>
                                <a
                                    (click)="startAssignment(assignment)"
                                    *ngIf="
                                        !assignment.completed && assignment.status === 'not_started'
                                    "
                                    class="student-tab__button"
                                    >Start</a
                                >
                            </span>
                        </div>
                        <div *ngIf="isActive(assignment.id)" class="show-info clearfix">
                            <span class="info-item"
                                ><b>Code:</b> {{ assignment.activity.code }}</span
                            >
                            <span class="info-item"
                                ><b>Date:</b>
                                {{ assignment.dateCreated | date: "MMMM d, yyyy" }}</span
                            >
                            <span class="info-item"
                                ><b>Teacher:</b> {{ assignment.activity.teacherName }}</span
                            >
                            <span *ngIf="assignment.rosters" class="info-item"
                                ><b>Classes:</b> {{ assignment.rosters }}</span
                            >
                            <div
                                class="info-desc"
                                [innerHTML]="
                                    assignment.activity.description | bypassSecurity: 'html'
                                "
                            ></div>
                            <a
                                *ngIf="assignment.completed"
                                class="info-retake"
                                href="{{ assignment.studentResultURL }}"
                                target="_self"
                            >
                                <span>Retake</span>
                                this assignment
                                <i class="lm lm-right-arrow"></i>
                            </a>
                        </div>
                    </li>
                </ng-container>
            </ul>
            <div
                [ngClass]="{ closed: !assignments.nextURL || isLoadingMoreAssignments }"
                class="show-more-results std-mgb"
            >
                <span (click)="showMore()" class="btn btn-show-more"> Show More </span>
            </div>
        </div>
    </div>
</div>
